export enum Permission {
  ManageUsers = 'manage_users.legacy_permission',
  AccountManagementAdminPanel = 'admin_panel.legacy_permission',
  AdminAccountManagement = 'admin_account_management.legacy_permission',
  PartnerDocsManagement = 'partner_docs.manage_roles',
  ViewWarehouseSecurity = 'warehouse_security.view',
  ManageWarehouseSecurity = 'warehouse_security.modify',
  ImpersonateUser = 'ipp_user_impersonation.modify',
}
